import React, { useEffect, useMemo, useState } from 'react';
import BreadCrumb from 'Common/BreadCrumb';
import { Dropdown } from 'Common/Components/Dropdown';
import { Eye, Trash2, Plus, MoreHorizontal, FileEdit, SlidersHorizontal, X } from 'lucide-react';
import dummyImg from "assets/images/users/user-dummy-img.jpg";
import { Link } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import filterDataBySearch from 'Common/filterDataBySearch';
import Pagination from 'Common/Pagination';
import { apiFetch } from "../../api/api";
import { AxiosError } from "axios";
import { useNavigate } from "react-router-dom";


const FormsView = () => {
    const navigate = useNavigate();
    const [dataList, setDataList] = useState<any[]>([]);
    const [data, setData] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null);

    const [showModal, setShowModal] = useState(false);
    const [newTitle, setNewTitle] = useState('');

    // 📦 دریافت داده‌ها از وب‌سرویس
    const handleScales = async (flg: number) => {
        try {
            setLoading(true);
            const res = await apiFetch({
                data: { params: [null, null, null, null, null, flg, 1, null] },
            });

            if (res.success && Array.isArray(res.rows)) {
                const formatted = res.rows.map((item: any) => ({
                    id: item.FID,
                    name: item.Title,
                    username: item.Description,
                    address: item.EndDate || "—",
                    img: dummyImg,
                    isActive: item.Status === "1", // فعال یا غیرفعال
                    views: item.Views || 0,
                    answers: item.Answers || 0,
                }));
                setDataList(formatted);
            } else {
                setError("No data found or invalid response.");
            }
        } catch (error) {
            const axiosError = error as AxiosError;
            alert(axiosError.message);
            console.error("saving error:", axiosError.message);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        handleScales(4);
    }, []);

    // 🔍 جستجو
    const filterSearchData = (e: any) => {
        const search = e.target.value;
        const keysToSearch = ['name', 'username'];
        filterDataBySearch(dataList, search, keysToSearch, setData);
    };

    // 📑 صفحه‌بندی
    const [currentPage, setCurrentPage] = useState<any>(1);
    const perPageData = 12;
    const indexOfLast = currentPage * perPageData;
    const indexOfFirst = indexOfLast - perPageData;
    const currentdata = useMemo(
        () => dataList?.slice(indexOfFirst, indexOfLast),
        [dataList, indexOfFirst, indexOfLast]
    );

    useEffect(() => {
        setData(currentdata);
    }, [currentdata]);

    function handleUpdateDataClick(item: any): void {
        console.log("Edit clicked for:", item);
    }

    function onClickDelete(item: any): void {
        console.log("Delete clicked for:", item);
    }

    // ➕ افزودن آیتم جدید
    const handleAddItem = async () => {
        if (!newTitle.trim()) {
            toast.warning('لطفاً عنوان را وارد کنید');
            return;
        }

        try {
            const res = await apiFetch({
                data: { params: [null, newTitle, null, 1, null, 1, 1, null] },
            });

            if (res.success) {
                toast.success('آیتم با موفقیت افزوده شد');
                setShowModal(false);
                setNewTitle('');
                handleScales(4); // بازخوانی لیست
            } else {
                toast.error('خطا در افزودن آیتم');
            }
        } catch (error) {
            const axiosError = error as AxiosError;
            toast.error(`خطا: ${axiosError.message}`);
        }
    };

    // 🌀 لودینگ اسپینر
    if (loading) {
        return (
            <div className="flex flex-col items-center justify-center min-h-[70vh]">
                <div className="w-12 h-12 border-4 border-custom-500 border-t-transparent rounded-full animate-spin"></div>
                <p className="mt-4 text-slate-600 dark:text-zink-200">در حال بارگذاری داده‌ها...</p>
            </div>
        );
    }

    // ❗ خطا در دریافت داده‌ها
    if (error) {
        return (
            <div className="flex flex-col items-center justify-center min-h-[70vh] text-red-500">
                <p>{error}</p>
                <button
                    onClick={() => handleScales(4)}
                    className="mt-3 btn bg-custom-500 text-white px-4 py-2 rounded-lg hover:bg-custom-600"
                >تلاش مجدد
                </button>
            </div>
        );
    }

    return (
        <React.Fragment>
          
            <ToastContainer closeButton={false} limit={1} />

            {/* 🔍 فیلتر و جستجو */}
            <form action="#!" className="mb-5 mt-6">
                <div className="grid grid-cols-1 gap-5 lg:grid-cols-12">
                    <div className="relative lg:col-span-4 xl:col-span-3">
                        <input
                            type="text"
                            className="ltr:pl-8 rtl:pr-8 form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 dark:focus:border-custom-800 dark:bg-zink-700 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                            placeholder="جستجو بر اساس نام یا توضیحات..."
                            autoComplete="off"
                            onChange={filterSearchData}
                        />
                    </div>
                    <div className="lg:col-span-3 lg:col-start-10">
                        <div className="flex gap-2 lg:justify-end">
                            <button
                                type="button"
                                className="text-white btn bg-custom-500 border-custom-500 hover:bg-custom-600"
                                onClick={() => setShowModal(true)}
                            >
                                <Plus className="inline-block size-4" /> <span>افزودن</span>
                            </button>
                          
                        </div>
                    </div>
                </div>
            </form>

            {/* 🧩 کارت‌ها */}
            <div className="grid grid-cols-1 gap-5 md:grid-cols-2 xl:grid-cols-4 mb-10
            ">
                {(data || []).map((item: any, key: number) => (
                    <div
                        key={key}
                        onClick={() => navigate(`/forms/${item.id}`)}
                        className="flex bg-white dark:bg-zink-700 rounded-2xl overflow-hidden shadow-sm hover:shadow-md transition-all duration-300"
                    >
                        {/* چپ: اطلاعات و منو */}
                        <div className="w-1/3 p-3 flex flex-col justify-between text-right">
                            <div className="space-y-1.5">
                                <div>
                                    <p className="text-slate-500 dark:text-zink-300 text-xs">بازدید</p>
                                    <p className="font-medium text-base text-slate-900 dark:text-white">
                                        {item.views}
                                    </p>
                                </div>
                                <div>
                                    <p className="text-slate-500 dark:text-zink-300 text-xs">پاسخ</p>
                                    <p className="font-medium text-base text-slate-900 dark:text-white">
                                        {item.answers}
                                    </p>
                                </div>
                                <div>
                                    <p className="text-slate-500 dark:text-zink-300 text-xs">وضعیت</p>
                                    <p
                                        className={`font-medium ${
                                            item.isActive ? 'text-green-600' : 'text-gray-500'
                                        }`}
                                    >
                                        {item.isActive ? "فعال" : "غیرفعال"}
                                    </p>
                                </div>
                            </div>

                            {/* دکمه منو */}
                            <div className="flex justify-start mt-2">
                                <Dropdown className="relative">
                                    <Dropdown.Trigger
                                        type="button"
                                        id={`dropdown-${key}`}
                                        className="flex items-center justify-center size-[30px] text-slate-700 bg-slate-100 border border-slate-300 rounded-md hover:bg-slate-200 dark:bg-zink-600 dark:border-zink-500"
                                    >
                                        <MoreHorizontal className="size-4" />
                                    </Dropdown.Trigger>
                                    <Dropdown.Content className="absolute z-50 py-2 mt-1 bg-white rounded-md shadow-md min-w-[10rem] dark:bg-zink-600">
                                        <li>
                                            <Link
                                                to="/pages-account"
                                                className="block px-4 py-1 text-base text-slate-600 hover:bg-slate-100"
                                            >
                                                <Eye className="inline-block size-3 mr-1" /> مشاهده
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="#!"
                                                onClick={() => handleUpdateDataClick(item)}
                                                className="block px-4 py-1 text-base text-slate-600 hover:bg-slate-100"
                                            >
                                                <FileEdit className="inline-block size-3 mr-1" /> ویرایش
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="#!"
                                                onClick={() => onClickDelete(item)}
                                                className="block px-4 py-1 text-base text-slate-600 hover:bg-slate-100"
                                            >
                                                <Trash2 className="inline-block size-3 mr-1" /> حذف
                                            </Link>
                                        </li>
                                    </Dropdown.Content>
                                </Dropdown>
                            </div>
                        </div>

                        {/* راست: پس‌زمینه رنگی با عنوان */}
                        <div
                            className={`w-2/3 flex items-center justify-center text-base font-bold text-slate-800 dark:text-white ${
                                item.isActive ? 'bg-blue-100 dark:bg-blue-900' : 'bg-gray-200 dark:bg-zink-800'
                            }`}
                        >
                            {item.name}
                        </div>
                    </div>
                ))}
            </div>

            <Pagination
                perPageData={perPageData}
                data={dataList}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                currentdata={currentdata}
            />

            {/* 🪟 Modal افزودن */}
            {showModal && (
                <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50">
                    <div className="bg-white dark:bg-zink-700 rounded-xl shadow-xl w-[90%] max-w-md p-6 relative">
                        <button
                            onClick={() => setShowModal(false)}
                            className="absolute top-3 left-3 text-gray-500 hover:text-gray-700"
                        >
                            <X className="size-5" />
                        </button>
                        <h3 className="text-lg font-semibold mb-4 text-center text-slate-800 dark:text-white">
                             افزودن پرسشنامه جدید
                        </h3>
                        <input
                            type="text"
                            value={newTitle}
                            onChange={(e) => setNewTitle(e.target.value)}
                            placeholder="عنوان جدید را وارد کنید..."
                            className="w-full border border-slate-300 rounded-lg p-2 text-sm focus:outline-none focus:ring-1 focus:ring-custom-500 dark:bg-zink-600 dark:text-white"
                        />
                        <div className="flex justify-center mt-5">
                            <button
                                onClick={handleAddItem}
                                className="bg-custom-500 text-white px-6 py-2 rounded-lg hover:bg-custom-600 transition"
                            >
                                ثبت
                            </button>
                        </div>
                    </div>
                </div>
            )}
        </React.Fragment>
    );
};

export default FormsView;
